<template>
  <div class="anesthetic-input border rounded p-2 mb-2">
    <b-form-checkbox
      :id="`${idPrefix}-anesthetic-used`"
      :checked="!!value"
      class="font-weight-bold"
      @change="toggle"
    >
      หัตถการนี้ใช้ยาชา
    </b-form-checkbox>
    <div v-if="value" class="mt-2">
      <b-form-row>
        <b-col cols="12" md="6" class="mb-1">
          <b-form-select
            :id="`${idPrefix}-anesthetic-item`"
            :value="value.itemId"
            :options="options"
            value-field="id"
            text-field="nameTh"
            size="sm"
            @change="update({ itemId: $event })"
          >
            <template v-slot:first>
              <b-form-select-option :value="null" disabled
                >-- เลือกยาชา --</b-form-select-option
              >
            </template>
          </b-form-select>
        </b-col>
        <b-col cols="4" md="2" class="mb-1">
          <b-input-group size="sm" append="carp">
            <b-form-input
              :id="`${idPrefix}-anesthetic-carpules`"
              :value="value.carpules"
              type="number"
              min="0.5"
              max="20"
              step="0.5"
              number
              @input="update({ carpules: $event })"
            />
          </b-input-group>
        </b-col>
        <b-col cols="4" md="2" class="mb-1">
          <b-input-group size="sm" append="ml">
            <b-form-input :value="show(result.totalMl)" disabled />
          </b-input-group>
        </b-col>
        <b-col cols="4" md="2" class="mb-1">
          <b-input-group size="sm" append="mg">
            <b-form-input :value="show(result.totalMg)" disabled />
          </b-input-group>
        </b-col>
      </b-form-row>
      <div
        v-if="result.maxMg !== null"
        class="small-text"
        :class="{
          'text-success': result.level === 'ok',
          'alert alert-warning py-1 px-2 mb-0': result.level === 'warning',
          'alert alert-danger py-1 px-2 mb-0': result.level === 'danger',
        }"
      >
        <span v-if="result.level === 'warning'">ใกล้ขนาดสูงสุด · </span>
        <span v-if="result.level === 'danger'">เกินขนาดสูงสุด · </span>
        {{ selected ? selected.nameTh : "" }} รวม {{ show(result.totalMg) }} mg ·
        ขนาดสูงสุด {{ result.maxMg }} mg ({{ selected.maxMgPerKg }} mg/kg ×
        {{ weightKg }} kg)
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { computeAnesthetic } from "@/utils/anesthetic";

const LAST_KEY = "aaci.lastAnesthetic";

const readLast = () => {
  try {
    const v = window.localStorage.getItem(LAST_KEY);
    return v ? Number(v) : null;
  } catch (e) {
    return null;
  }
};

const writeLast = id => {
  try {
    window.localStorage.setItem(LAST_KEY, String(id));
  } catch (e) {
    // storage unavailable; remembering the last drug is only a convenience
  }
};

export default {
  name: "AnestheticInput",
  props: {
    value: { type: Object, default: null },
    weightKg: { type: Number, default: null },
    idPrefix: { type: String, default: "tx" },
  },
  computed: {
    ...mapGetters({ itemList: "moduleAppointment/getItemList" }),
    options() {
      return (this.itemList || []).filter(i => i.isAnesthetic);
    },
    selected() {
      if (!this.value) return null;
      return this.options.find(i => i.id === this.value.itemId) || null;
    },
    result() {
      const s = this.selected || {};
      return computeAnesthetic({
        carpules: this.value ? this.value.carpules : null,
        carpuleMl: s.carpuleMl,
        mgPerMl: s.mgPerMl,
        maxMgPerKg: s.maxMgPerKg,
        weightKg: this.weightKg,
      });
    },
  },
  methods: {
    toggle(checked) {
      if (!checked) {
        this.$emit("input", null);
        return;
      }
      const last = readLast();
      const lastValid = this.options.some(i => i.id === last) ? last : null;
      const first = this.options.length === 1 ? this.options[0].id : null;
      this.$emit("input", { itemId: lastValid || first, carpules: 1 });
    },
    update(patch) {
      const next = { ...this.value, ...patch };
      if (patch.itemId) writeLast(patch.itemId);
      this.$emit("input", next);
    },
    show(v) {
      return v === null || v === undefined ? "-" : v;
    },
  },
};
</script>
